import { AccessType } from 'app/auth/accessControlService'
import { Routes } from 'app/services/routeService/routeService'

import PlanBilling from './billingOverview/PlanBilling'
import UsageSummary from './usageSummary/UsageSummary'
import UsageHistory from './usageHistory/UsageHistory'
import AIUsageHistory from './aiUsageLog/AiUsageLog'

export const PlansAndBilliingConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.billingOverview(),
      component: PlanBilling,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: Routes.usageSummary(),
      component: UsageSummary,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: Routes.usageHistory(),
      component: UsageHistory,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: Routes.aiUsageLog(),
      component: AIUsageHistory,
      accesses: [AccessType.ADMINISTRATION],
    },
  ],
}
